/**
 * staleTime for task COLLECTION queries (kanban columns, list groups, calendar,
 * gantt rows). Freshness after this window is maintained by the normalized
 * entity cache (updateTaskEntity) and SignalR realtime events, so this can be
 * generous — it exists to stop view-switch remounts from refetching.
 */
export const TASK_COLLECTION_STALE_TIME = 1000 * 60 * 5; // 5 min, matches global default
